import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@lognai/synapse-design-system-v2/styles.css';
import 'leaflet/dist/leaflet.css';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
